import { useState } from "react";
import { documentLinePreviewUrl, documentPdfUrl } from "../api/documents";
import { isDemoMode } from "../lib/env";
import { useDocumentMediaTokenState } from "./DocumentPdfActions";

/** Canonical document evidence; never reconstruct an original from parsed values. */
export default function QualityReviewOriginal({
  docId, linePos, docNumber,
}: {
  docId: string;
  linePos: string | null;
  docNumber: string | null;
}) {
  const { token, isError, retry } = useDocumentMediaTokenState(!isDemoMode());
  const [failed, setFailed] = useState(false);
  const [zoomed, setZoomed] = useState(false);
  const ready = Boolean(token) || isDemoMode();
  return (
    <section className="min-w-0 rounded-lg border border-slate-200 bg-slate-50 lg:sticky lg:top-[var(--app-header-h,0px)] lg:self-start">
      <header className="flex flex-wrap items-center justify-between gap-2 border-b border-slate-200 px-4 py-3">
        <h3 className="text-sm font-semibold text-slate-900">Originalbeleg</h3>
        {ready ? <a href={documentPdfUrl(docId, null, token)} target="_blank" rel="noreferrer"
          className="text-sm font-medium text-emerald-700 underline underline-offset-2">Ganzes PDF öffnen</a> : null}
      </header>
      <div className="p-4">
        <p className="mb-3 text-sm text-slate-600">Beleg {docNumber ?? docId}{linePos ? ` · Position ${linePos}` : ""}</p>
        {isError && !ready ? <div className="text-sm text-slate-600"><p>Das Original konnte nicht geladen werden.</p><button type="button" onClick={() => void retry()} className="mt-2 h-9 rounded-md border border-slate-300 bg-white px-3">Erneut laden</button></div> : !ready ? <p className="text-sm text-slate-600" role="status">Original wird geladen …</p> :
          failed || !linePos ? <p className="text-sm text-slate-600">Die Position kann hier nicht angezeigt werden. Öffne das ganze PDF, um die Angaben zu vergleichen.</p> :
          <>
            <button type="button" onClick={() => setZoomed(!zoomed)} aria-pressed={zoomed}
              className="mb-3 h-9 rounded-md border border-slate-300 bg-white px-3 text-sm text-slate-700">
              {zoomed ? "Einpassen" : "Vergrößern"}
            </button>
            <div className="overflow-auto" tabIndex={zoomed ? 0 : undefined} aria-label="Originalausschnitt">
              <img src={documentLinePreviewUrl(docId, linePos, 2, token)}
                alt={`Originalausschnitt zu Position ${linePos}`} onError={() => setFailed(true)}
                className={`h-auto w-full rounded border border-slate-200 bg-white ${zoomed ? "min-w-[1000px]" : ""}`} />
            </div>
          </>}
      </div>
    </section>
  );
}
